import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import master from './modules/master'
import signup from './modules/signup'
import preferences from './modules/preferences'
import taxSetting from './modules/taxSetting'
import shop from './modules/shop'
import document from './modules/document'
import taskCategory from './modules/taskCategory'
import teamCategory from './modules/teamCategory'
import saleCategory from './modules/saleCategory'
import customerTag from './modules/customerTag'
import saleTag from './modules/saleTag'
import contactTag from './modules/contactTag'
import communicationTemplate from './modules/communicationTemplate'
import userGroup from './modules/userGroup'
import itemCategory from './modules/itemCategory'
import tailoringCollection from './modules/tailoringCollection'
import tailoringSize from './modules/tailoringSize'
import measurementTemplate from './modules/measurementTemplate'
import productionStage from './modules/productionStage'
import tailoringMaster from './modules/tailoringMaster'
import leaveMaster from './modules/leaveMaster'
import overtimeMaster from './modules/overtimeMaster'
import holidayMaster from './modules/holidayMaster'
import designationMaster from './modules/designationMaster'
import employee from './modules/employee'
import genericContact from './modules/genericContact'
import teamList from './modules/teamList'
import leaveApplication from './modules/leaveApplication'
import attendanceEntry from './modules/attendanceEntry'
import bankMaster from './modules/bankMaster'
import paymentMode from './modules/paymentMode'
import currencyExchange from './modules/currencyExchange'
import expenseCategory from './modules/expenseCategory'
import expenseJournal from './modules/expenseJournal'
import contraEntry from './modules/contraEntry'
import fabricPriceSlab from './modules/fabricPriceSlab'
import inventoryVariant from './modules/inventoryVariant'
import vendorMaster from './modules/vendorMaster'
import inventoryMaster from './modules/inventoryMaster'
import inventoryOrder from './modules/inventoryOrder' 
import inventoryInvoice from './modules/inventoryInvoice' 
import vendorPayment from './modules/vendorPayment' 
import inventoryIntraBranch from './modules/inventoryIntraBranch' 
import inventorySourcing from './modules/inventorySourcing' 
import inventoryStockCheck from './modules/inventoryStockCheck' 
import customerMaster from './modules/customerMaster' 
import saleMaster from './modules/saleMaster' 
import customerPayment from './modules/customerPayment' 
import workOrder from './modules/workOrder' 
import giftCard from './modules/giftCard' 
import saleDelivery from './modules/saleDelivery' 
import production from './modules/production'  
import productionItemIssue from './modules/productionItemIssue'  
import transferWorkOrder from './modules/transferWorkOrder' 
import productionOutsource from './modules/productionOutsource'
import inventorySeparation from './modules/inventorySeparation'
import discountCoupon from './modules/discountCoupon'
import productionCapacity from './modules/productionCapacity'
import employeeLoan from './modules/employeeLoan'
import employeePayroll from './modules/employeePayroll'
import inventoryRack from './modules/inventoryRack'
import measurementMaster from './modules/measurementMaster'
import assetMaster from './modules/assetMaster'
import bankStatement from './modules/bankStatement'
import tasks from './modules/tasks'
import shipmentPartner from './modules/shipmentPartner'
import handloomCluster from './modules/handloomCluster'
import expenseBill from './modules/expenseBill'
import letterTemplate from './modules/letterTemplate'
import lostDamaged from './modules/lostDamaged'
import eStoreOrder from './modules/eStoreOrder'
import news from './modules/news'
import eStoreCatalog from './modules/eStoreCatalog'
import dataBackup from './modules/dataBackup'
import tailoringTrialType from './modules/tailoringTrialType'
import campaign from './modules/campaign'
import eStoreCategory from './modules/eStoreCategory'
import eStoreTopMenu from './modules/eStoreTopMenu' 
import eStoreProduct from './modules/eStoreProduct' 
import eStoreHomePage from './modules/eStoreHomePage' 
import garmentCustomiser from './modules/garmentCustomiser'

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    garmentCustomiser,
    master, 
    signup, 
    preferences, 
    taxSetting, 
    shop, 
    document, 
    taskCategory, 
    teamCategory,
    saleCategory,
    customerTag,
    saleTag,
    contactTag,
    communicationTemplate,
    userGroup,
    itemCategory,
    tailoringCollection,
    tailoringSize,
    measurementTemplate,
    productionStage,
    tailoringMaster,
    leaveMaster,
    overtimeMaster,
    holidayMaster,
    designationMaster,
    employee,
    genericContact,
    teamList,
    leaveApplication,
    attendanceEntry,
    bankMaster,
    paymentMode,
    currencyExchange,
    expenseCategory,
    expenseJournal,
    contraEntry,
    fabricPriceSlab,
    inventoryVariant,
    vendorMaster,
    inventoryMaster,
    inventoryOrder,
    inventoryInvoice,
    vendorPayment,
    inventoryIntraBranch,
    inventorySourcing,
    inventoryStockCheck,
    customerMaster,
    saleMaster,
    customerPayment,
    workOrder,
    giftCard,
    saleDelivery,
    production,
    productionItemIssue,
    transferWorkOrder,
    productionOutsource,
    inventorySeparation,
    discountCoupon,
    productionCapacity,
    employeeLoan,
    employeePayroll,
    inventoryRack,
    measurementMaster,
    assetMaster,
    bankStatement,
    tasks,
    shipmentPartner,
    handloomCluster,
    expenseBill,
    letterTemplate,
    lostDamaged,
    eStoreOrder,
    news,
    eStoreCatalog,
    dataBackup,
    tailoringTrialType,
    campaign,
    eStoreCategory,
    eStoreTopMenu,
    eStoreProduct,
    eStoreHomePage
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js